<template>
  <div id="tab-kol-entity">
    <div class="row">
      <!-- top kol/entity -->
      <div class="col-md-12 px-gap mt-1">
        <div class="bg-white rounded p-3 shade">
          <div class="h5">Top Kol/Entity</div>
          <div class="scroll-container d-flex mt-4" id="scroll-container">
            <div
              v-for="(item, index) in top_kol_entity"
              :key="index"
              class="mr-2"
            >
              <div
                class="content-wrap text-center clickable hoverable"
                style="border-radius: 5px; height: 100%"
              >
                <img
                  :src="item.image"
                  style="
                    border-radius: 50%;
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                  "
                />
                <div
                  class="px-2 text-center font-weight-bold mt-2 mb-3"
                  style="height: 2.5rem"
                >
                  <span class="text-name">
                    {{ writeName(item.name) }}
                  </span>
                </div>
                <div class="badge badge-success text-white">
                  {{ item.news_count }} News
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex px-2">
            <div style="margin-top: -11%" @click="scrollLeft">
              <button
                class="btn btn-icon btn-success"
                style="margin-left: -15px"
                @click="scrollLeft"
              >
                <i class="bi bi-chevron-left"></i>
              </button>
            </div>
            <div class="ml-auto" style="margin-top: -11%" @click="scrollRight">
              <button
                class="btn btn-icon btn-success"
                style="margin-right: -15px"
                @click="scrollRight"
              >
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- entity detail -->
      <div class="col-md-12 mt-4">
        <div class="row">
          <!-- entity info -->
          <div class="col-md-6 px-gap">
            <div class="bg-white shade p-3 h-100">
              <div class="h4">Joko Widodo</div>
              <div class="h6">Presiden Republik Indonesia</div>
              <div class="d-flex mt-3">
                <img
                  :src="entity_selected.image"
                  width="120"
                  class="rounded-lg"
                />
                <div class="ml-3 d-flex flex-wrap" style="height: max-content">
                  <div
                    v-for="(item, index) in entity_selected.topic"
                    :key="index"
                    class="badge rounded bg-complete text-white mr-2 mb-2"
                    style="height: 1.2rem"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div>Covered in 171 article</div>
                <div>Social Media Coverage 0</div>
              </div>
              <div class="mt-3">
                <h6 class="text-blue">Related Persons:</h6>
                <div class="text-justify">
                  <div>
                    Prajogo Pangestu, Agus Salim Pangestu, Nieko Kusuma, Michael
                    Hartono, Hendra Soetjipto Tan, Low Tuck Kwong, Sri Prakash
                    Lohia, R Budi Hartono, Robert Budi Hartono, Fajar Dwi
                    Alfian,
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <h6 class="text-blue">Related Organizations:</h6>
                <div class="text-justify">
                  <div>
                    BREN, Bursa Efek Indonesia, PT Barito Renewables Energy Tbk,
                    Pt Barito Pacific Tbk, BRPT, Bangkok Bank Public Company
                    Limited, TPIA, SEOG, Grup Barito, PT Chandra Asri
                    Petrochemical Tbk,
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <h6 class="text-blue">Related Brand/ Product:</h6>
                <div class="text-justify">
                  <div>
                    batu bara, Batu Bara, BREN, Bisniscom, CPO, BBM, batu bara
                    metalurgi, ICI4, pasir silika, batu bara termal Newcastle,
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <h6 class="text-blue">Related Locations:</h6>
                <div class="text-justify">
                  <div>
                    DKI Jakarta, Indonesia, Amerika Serikat, Israel, Kalimantan
                    Barat, Asia Tenggara, Darajat, Jawa Barat, Republik Rakyat
                    China, Kabupaten Garut,
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- sentiment -->
          <div class="col-md-6 px-gap">
            <div class="bg-white shade p-3">
              <line-chart-component
                :series="sentiment_chart_data"
                el="linechart-entity-sentiment"
              />
            </div>
            <div class="bg-white shade p-3 mt-4">
              <div class="h5">Media Coverage</div>
              <pie-chart-component :data="media_coverage_data" />
            </div>
          </div>
        </div>
      </div>
      <!-- statement list -->
      <div class="col-md-12 mt-4">
        <div class="row">
          <div class="col-md-7 px-gap">
            <div class="bg-white shade p-3 h-100">
              <div class="h5">Daftar Statement</div>
              <statement-list-component :quotes="statement_data" />
            </div>
          </div>
          <div class="col-md-5 px-gap">
            <div class="bg-white shade p-3 h-100">
              <div class="h5">Sentimen Analisis</div>
              <div class="scroller-x d-flex mt-3">
                <div v-for="(item, index) in media_filter" :key="index">
                  <div
                    class="border rounded p-1 text-center mr-1 clickable hoverable"
                    :class="selected_media.id == item.id ? 'bg-active' : ''"
                    style="font-size: 10px; width: 90px !important"
                    @click="changeSelectedMedia(item)"
                  >
                    <i :class="item.icon"></i>
                    <br />
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <pie-chart-component :data="sentiment_pie_chart_data" />
            </div>
          </div>
        </div>
      </div>
      <!-- news list -->
      <div class="col-md-12 px-gap mt-4">
        <div class="bg-white shade p-3">
          <div class="h5">Daftar Berita Terkait</div>
          <kol-entity-post-list-component :post="post_data" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import line_chart from "@/views/components/chart/line_chart.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import statement_list from "@/views/components/quotes-extraction/statement_list.vue";
import kol_entity_post_list from "@/views/components/quotes-extraction/kol_entity_post_list.vue";

export default {
  name: "tab_kol_entity",
  components: {
    "line-chart-component": line_chart,
    "pie-chart-component": pie_chart,
    "statement-list-component": statement_list,
    "kol-entity-post-list-component": kol_entity_post_list,
  },
  data() {
    return {
      selected_media: {
        id: "all",
        title: "Semua Media",
        icon: "bi bi-layout-text-sidebar",
      },
      media_filter: [
        {
          id: "all",
          title: "Semua Media",
          icon: "bi bi-layout-text-sidebar",
        },
        {
          id: "news",
          title: "Online News",
          icon: "bi bi-globe-americas",
        },
        {
          id: "media_cetak",
          title: "Media Cetak",
          icon: "bi bi-newspaper",
        },
        {
          id: "media_tv",
          title: "Media TV",
          icon: "bi bi-tv",
        },
        {
          id: "twitter",
          title: "Twitter",
          icon: "bi bi-twitter",
        },
        {
          id: "facebook",
          title: "Facebook",
          icon: "bi bi-facebook",
        },
        {
          id: "instagram",
          title: "Instagram",
          icon: "bi bi-instagram",
        },
        {
          id: "youtube",
          title: "Youtube",
          icon: "bi bi-youtube",
        },
        {
          id: "forum",
          title: "Forum",
          icon: "bi bi-chat-dots-fill",
        },
        {
          id: "blog",
          title: "Blog",
          icon: "bi bi-rss",
        },
        {
          id: "linkedin",
          title: "Linkedin",
          icon: "bi bi-linkedin",
        },
        {
          id: "tiktok",
          title: "Tiktok",
          icon: "bi bi-tiktok",
        },
        {
          id: "review",
          title: "Review Aplikasi",
          icon: "bi bi-phone",
        },
      ],
      entity_selected: {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Joko_Widodo_2019_official_portrait.jpg/320px-Joko_Widodo_2019_official_portrait.jpg",
        name: "Joko Widodo",
        topic: [
          "Health Care Equipment and Services",
          "Transportation",
          "Commercial and Professional Services",
          "Presiden",
          "Pharmaceuticals Biotechnology and Life Sciences",
          "Automobiles and Components",
        ],
        news_count: 200,
      },
      top_kol_entity: [
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Gubernur_DKI_Basuki_TP_%E9%90%98%E8%90%AC%E5%AD%B8.jpg/320px-Gubernur_DKI_Basuki_TP_%E9%90%98%E8%90%AC%E5%AD%B8.jpg",
          name: "Basuki Tcahaja Purnama",
          news_count: 2000,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Menteri_Pertahanan_Prabowo_Subianto.jpg/320px-Menteri_Pertahanan_Prabowo_Subianto.jpg",
          name: "Prabowo Subianto",
          news_count: 2500,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Ganjar_Pranowo%2C_Gubernur_Jateng_Periode_II.jpg/320px-Ganjar_Pranowo%2C_Gubernur_Jateng_Periode_II.jpg",
          name: "Ganjar Pranowo",
          news_count: 2000,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Susilo_Bambang_Yudhoyono_2009_official_portrait.png/320px-Susilo_Bambang_Yudhoyono_2009_official_portrait.png",
          name: "Susilo Bambang Yudhoyono",
          news_count: 300,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/c/ca/Penny_K._Lukito.jpg",
          name: "Penny Kusumastuti Lukito",
          news_count: 200,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Joko_Widodo_2019_official_portrait.jpg/320px-Joko_Widodo_2019_official_portrait.jpg",
          name: "Joko Widodo",
          news_count: 200,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Cristiano_Ronaldo_WC2022_-_01.jpg/320px-Cristiano_Ronaldo_WC2022_-_01.jpg",
          name: "Christiano Ronaldo",
          news_count: 200,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Gubernur_Anies.jpg/320px-Gubernur_Anies.jpg",
          name: "Anies Baswedan",
          news_count: 200,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Gubernur_DKI_Basuki_TP_%E9%90%98%E8%90%AC%E5%AD%B8.jpg/320px-Gubernur_DKI_Basuki_TP_%E9%90%98%E8%90%AC%E5%AD%B8.jpg",
          name: "Basuki Tcahaja Purnama",
          news_count: 2000,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Menteri_Pertahanan_Prabowo_Subianto.jpg/320px-Menteri_Pertahanan_Prabowo_Subianto.jpg",
          name: "Prabowo Subianto",
          news_count: 2500,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Joko_Widodo_2019_official_portrait.jpg/320px-Joko_Widodo_2019_official_portrait.jpg",
          name: "Joko Widodo",
          news_count: 200,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Cristiano_Ronaldo_WC2022_-_01.jpg/320px-Cristiano_Ronaldo_WC2022_-_01.jpg",
          name: "Christiano Ronaldo",
          news_count: 200,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Joko_Widodo_2019_official_portrait.jpg/320px-Joko_Widodo_2019_official_portrait.jpg",
          name: "Joko Widodo",
          news_count: 200,
        },
        {
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Cristiano_Ronaldo_WC2022_-_01.jpg/320px-Cristiano_Ronaldo_WC2022_-_01.jpg",
          name: "Christiano Ronaldo",
          news_count: 200,
        },
      ],
      sentiment_chart_data: {
        x: [
          "05 Okt 2023",
          "06 Okt 2023",
          "07Okt 2023",
          "08 Okt 2023",
          "09 Okt 2023",
          "10 Okt 2023",
          "11 Okt 2023",
        ],
        y: [
          {
            color: "#28a745",
            data: [11498, 9544, 7110, 6020, 5032, 4053, 10490],
            name: "Positif",
          },
          {
            color: "#6c757d",
            data: [23044, 9544, 12313, 6020, 7685, 4053, 10490],
            name: "Netral",
          },
          {
            color: "#e83e8c",
            data: [45673, 9544, 5909, 6020, 7689, 4053, 10490],
            name: "Negatif",
          },
        ],
      },
      media_coverage_data: [
        {
          color: "#28a745",
          name: "Online News",
          y: 9284,
        },
        {
          color: "#6c757d",
          name: "Media Cetak",
          y: 9284,
        },
        {
          color: "#e83e8c",
          name: "Media TV",
          y: 9284,
        },
        {
          color: "#1da1f2",
          name: "Twitter",
          y: 9284,
        },
        {
          color: "#4267b2",
          name: "Facebook",
          y: 9284,
        },
        {
          color: "#e1306c",
          name: "Instagram",
          y: 9284,
        },
        {
          color: "#dc3545",
          name: "Youtube",
          y: 9284,
        },
        {
          color: "#6c757d",
          name: "Forum",
          y: 9284,
        },
        {
          color: "#ffc107",
          name: "Blog",
          y: 9284,
        },
        {
          color: "#dc3545AA",
          name: "Linkedin",
          y: 9284,
        },
        {
          color: "#000000",
          name: "Tiktok",
          y: 9284,
        },
        {
          color: "#000000",
          name: "Review Aplikasi",
          y: 9284,
        },
      ],
      sentiment_pie_chart_data: [
        {
          color: "#28a745",
          name: "Positif",
          y: 9284,
        },
        {
          color: "#0e6d87AA",
          name: "Netral",
          y: 9284,
        },
        {
          color: "#dc3545AA",
          name: "Negatif",
          y: 9284,
        },
      ],
      statement_data: [
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 0,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3d65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 1,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "6526957sdfad3d65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: -1,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578sdfd65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 1,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578dsdf65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 0,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "652695sdfad3d65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 0,
          source: "media_tv",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3d6sdfc8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 0,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3d65sdf8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 0,
          source: "media_cetak",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3dwerc23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 0,
          source: "media_cetak",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3dwe23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          speaker: "Joko Widodo",
          sentiment: 0,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          quote:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3d65c23123",
          },
        },
      ],
      post_data: [
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 0,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3d65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 1,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "6526957sdfad3d65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: -1,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578sdfd65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 1,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578dsdf65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 0,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "652695sdfad3d65c23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 0,
          source: "media_tv",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3d6sdfc8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 0,
          source: "news",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3d65sdf8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 0,
          source: "media_cetak",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto asasd asda asdasd asdasd asdasd asdasd asdasd",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3dwerc23c8e89",
          },
        },
        {
          account: "metrotvnews.com",
          title:
            "Golkar Ngotot Sodorkan Airlangga Hartarto jadi Cawapres Prabowo",
          sentiment: 0,
          source: "media_cetak",
          date: {
            $date: 1697015790000,
          },
          thumbnail:
            "https://cdn01.metrotvnews.com/content/2023/10/11/kWDCZYwq/t_652606148593a.jpg",
          content:
            "Ketua Umum Partai Golkar Airlangga Hartarto tetap akan didorong menjadi calon wakil presiden untuk Prabowo Subianto",
          id_project: 86,
          id_stream: {
            $oid: "65262390894601529a14574e",
          },
          _id: {
            $oid: "65269578d4ad3dwe23c8e89",
          },
        },
      ],
    };
  },
  methods: {
    writeName(name) {
      if (name.length > 25) {
        return name.substring(0, 25) + "...";
      }
      return name;
    },
    changeSelectedMedia(data) {
      this.selected_media = data;
    },
    scrollLeft() {
      const scroll_container = document.getElementById("scroll-container");
      const current_scroll = scroll_container.scrollLeft;
      scroll_container.scrollTo({
        left: current_scroll - 500,
        behavior: "smooth",
      });
    },
    scrollRight() {
      const scroll_container = document.getElementById("scroll-container");
      const current_scroll = scroll_container.scrollLeft;
      scroll_container.scrollTo({
        left: current_scroll + 500,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scoped>
.scroll-container {
  width: 100%;
  overflow-x: auto;
  transition: scroll-behavior 0.5s;
}
.scroll-container::-webkit-scrollbar {
  display: none;
}
.scroller-x {
  width: 100%;
  overflow-x: auto;
  transition: scroll-behavior 0.5s;
}
.scroller-x::-webkit-scrollbar {
  display: none;
}
.content-wrap {
  width: 150px !important;
}
.bg-active {
  background-color: #d3eeff;
}
.dark-mode .bg-active {
  background-color: #2e343a !important;
}
</style>